import { render } from "./EventHistory.vue?vue&type=template&id=6c99431e&scoped=true"
import script from "./EventHistory.vue?vue&type=script&lang=js"
export * from "./EventHistory.vue?vue&type=script&lang=js"

import "./EventHistory.vue?vue&type=style&index=0&id=6c99431e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c99431e"]])

export default __exports__